import mq from 'styled-media-query';

// mapped to Chakra UIs default breakpoints
export const mqSmall = mq.greaterThan('480px');
export const mqMedium = mq.greaterThan('768px');
export const mqLarge = mq.greaterThan('992px');
export const mqExtraLarge = mq.greaterThan('1280px');
